export default __webpack_public_path__ + "static/media/solar.b731ca9a.jpeg";